import { forwardRef, PropsWithChildren, useCallback } from 'react'
import Styles from './StackableCard.module.scss'
import { useMeasure } from 'react-use'

interface Props {
  position: number
  stackLength: number
  offset: number
}

export const StackableCard = forwardRef(
  ({ children, position = 1, stackLength = 1, offset }: PropsWithChildren<Props>, fRef) => {
    const [ref, { height }] = useMeasure<HTMLDivElement>()

    const callbackRef = useCallback(
      (node: HTMLDivElement | null) => {
        if (node) {
          ref(node)
        }

        if (fRef) {
          if (typeof fRef === 'function') {
            fRef(node)
          } else {
            fRef.current = node
          }
        }
      },
      [ref, fRef],
    )

    return (
      <div
        className={Styles.root}
        ref={callbackRef}
        style={{
          top: `${(position - 1) * 6 + offset - height}px`,
          zIndex: stackLength - position,
        }}
      >
        {children}
      </div>
    )
  },
)
